module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/45ft-30b263a5310d7f81dd0a468d49eca354.png";